import React from 'react'
import { Heading, Text } from 'front-end/src/components'
import { Trans } from '@lingui/macro'
import { brandColors } from 'shared/basicPalette'
import { useLoginContext } from 'front-end/src/pages/auth/login/LoginContext'
import { observer } from 'mobx-react'

export const WelcomeMessage: React.FC = observer(() => {
  const { organisation } = useLoginContext()

  return (
    <>
      <Heading size="md">
        <Trans>
          Welcome to <strong>{organisation?.name || 'Looop'}</strong>
        </Trans>
      </Heading>

      <Text pb="4px" pt="12px" color={brandColors.grey['800']}>
        <Trans>Log in to our learning platform</Trans>
      </Text>
    </>
  )
})

WelcomeMessage.displayName = 'WelcomeMessage'
